export const anchors = () => {
  const links = Array.from(
    document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])'),
  )

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      if (
        location.pathname.replace(/^\//, '') ==
          link.pathname.replace(/^\//, '') &&
        location.hostname == link.hostname
      ) {
        const target = link.hash

        if (target.length) {
          event.preventDefault()

          const targetElement = document.getElementById(
            link.hash.replace('#', ''),
          )

          window.scroll({
            top: targetElement.offsetTop - 20,
            left: 0,
            behavior: 'smooth',
          })

          if (targetElement.classList.contains('chart-button')) {
            const tabs = targetElement.parentNode
            const chartParent = tabs.parentNode
            const buttons = Array.from(tabs.querySelectorAll('.chart-button'))
            const charts = Array.from(
              chartParent.querySelectorAll('.comparison-chart__outer'),
            )

            buttons.forEach((b) => b.classList.remove('active'))
            charts.forEach((b) => b.classList.remove('active'))
            targetElement.classList.add('active')
            const buttonIndex = [].slice
              .call(tabs.children)
              .indexOf(targetElement)
            charts[buttonIndex].classList.add('active')
          }
        }
      }
    })
  })
}
